export const CUSTOM_COLOR_PREFIX = 'turn_' as const;

export const EMPTY_VALUES = new Set<unknown>([null, undefined, '', '-'] as const);
